<template>
  <v-card>
    <v-data-table
      :page.sync="page"
      @page-count="pageCount = $event"
      :items="students"
      :headers="headers"
      hide-default-footer
    >
      <template v-slot:item.invoice_no="{ item }">
        <span class="table-complete-name">QSL_{{ item.invoice_no }}</span>
      </template>

      <template v-slot:item.name="{ item }">
        <span class="table-complete-name">{{ item.name }}</span>
      </template>

      <template v-slot:item.status="{ item }">
        <span class="table-complete-status">{{ item.status }}</span>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon color="success">mdi-file-edit</v-icon>
        <v-icon color="red" @click.stop="delete_dialog = true">mdi-delete</v-icon>
      </template>
      <template v-slot:item.created_at="{ item }">
        <p>{{ item[0].created_at }}</p>
      </template>
    </v-data-table>
    <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Enquiries
        <span :style="{ color: this.$vuetify.theme.themes.light.primary }">{{
          students.length
        }}</span>
      </span>
      <v-spacer></v-spacer>
      <v-pagination circle v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "EarningTable",
  methods: {
    getZeroAddedNum(num) {
      return num.toString().padStart(2, "0");
    },
  },
  watch: {
    counter: function (val) {
      this.getItems();
    },
  },
  computed: {
    getBaseURL(url) {
      return window.baseURL;
    },
  },
  data() {
    return {
      delete_dialog: false,
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      headers: [
        {
          text: "Srno.",
          sortable: true,
          value: "srno",
        },
        {
          text: "Invoice No.",
          value: "invoice_no",
          sortable: false,
        },
        {
          text: "Student ID",
          sortable: true,
          value: "student_id",
        },
        {
          text: "Student Name",
          value: "name",
          sortable: true,
        },
        {
          text: "Class.",
          value: "class",
          sortable: false,
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
        },
        {
          text: "Created At",
          value: "created_at",
          sortable: false,
        },
        {
          text: "Start Date",
          value: "start_date",
          sortable: false,
        },
        {
          text: "End Date",
          value: "end_date",
          sortable: false,
        },
        {
          text: "Total Hours",
          value: "total_hours",
          sortable: false,
        },
        {
          text: "Amount",
          value: "amount",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}

.table-complete {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }

  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }

  &-status {
    font: 500 12px/13px Gotham;
    color: #e41b1bf7;
  }
}
</style>
